/*
 * Map and geometry utility helpers extracted from area-selector2.js
 */

(function() {
  'use strict';

  function toRad(deg) {
    return deg * (Math.PI / 180);
  }

  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Earth's radius in kilometers
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function formatDistance(km) {
    if (km < 1) {
      return `${Math.round(km * 1000)}m`;
    } else if (km < 10) {
      return `${km.toFixed(2)}km`;
    }
    return `${Math.round(km)}km`;
  }

  function transformCoordinatesForRotation(screenTopRightLat, screenTopRightLng, screenBottomLeftLat, screenBottomLeftLng, rotation) {
    const corners = {
      topRight: { lat: screenTopRightLat, lng: screenTopRightLng },
      bottomLeft: { lat: screenBottomLeftLat, lng: screenBottomLeftLng },
      topLeft: { lat: screenTopRightLat, lng: screenBottomLeftLng },
      bottomRight: { lat: screenBottomLeftLat, lng: screenTopRightLng }
    };

    let geographicTopRight;
    let geographicBottomLeft;

    switch (rotation) {
      case 0:
        geographicTopRight = corners.topRight;
        geographicBottomLeft = corners.bottomLeft;
        break;
      case 90:
        geographicTopRight = corners.bottomRight;
        geographicBottomLeft = corners.topLeft;
        break;
      case 180:
        geographicTopRight = corners.bottomLeft;
        geographicBottomLeft = corners.topRight;
        break;
      case 270:
        geographicTopRight = corners.topLeft;
        geographicBottomLeft = corners.bottomRight;
        break;
      default:
        console.warn(`Invalid rotation ${rotation}°, defaulting to North up`);
        geographicTopRight = corners.topRight;
        geographicBottomLeft = corners.bottomLeft;
    }

    return {
      topRight: geographicTopRight,
      bottomLeft: geographicBottomLeft
    };
  }

  function createBezierEasing(x1, y1, x2, y2) {
    return function(t) {
      const cx = 3 * x1;
      const bx = 3 * (x2 - x1) - cx;
      const ax = 1 - cx - bx;

      const cy = 3 * y1;
      const by = 3 * (y2 - y1) - cy;
      const ay = 1 - cy - by;

      function sampleCurveX(t) {
        return ((ax * t + bx) * t + cx) * t;
      }

      function sampleCurveY(t) {
        return ((ay * t + by) * t + cy) * t;
      }

      function solveCurveX(x) {
        let t0;
        let t1;
        let t2 = x;
        let x2;
        let d2;
        let i;

        for (i = 0; i < 8; i++) {
          x2 = sampleCurveX(t2) - x;
          if (Math.abs(x2) < 1e-6) return t2;
          d2 = (3 * ax * t2 + 2 * bx) * t2 + cx;
          if (Math.abs(d2) < 1e-6) break;
          t2 -= x2 / d2;
        }

        t0 = 0;
        t1 = 1;
        t2 = x;

        while (t0 < t1) {
          x2 = sampleCurveX(t2);
          if (Math.abs(x2 - x) < 1e-6) return t2;
          if (x > x2) {
            t0 = t2;
          } else {
            t1 = t2;
          }
          t2 = (t1 - t0) * 0.5 + t0;
        }

        return t2;
      }

      return sampleCurveY(solveCurveX(t));
    };
  }

  const exported = {
    toRad,
    calculateDistance,
    formatDistance,
    transformCoordinatesForRotation,
    createBezierEasing
  };

  window.Landmark = window.Landmark || {};
  window.Landmark.MapUtils = exported;
})();
